export default __webpack_public_path__ + "static/media/PWV.f3371800.svg";